var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-overlay',[_c(_vm.errorMessage,{tag:"component",attrs:{"error":_vm.error}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }